import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { InfoBox } from '../common'
import Channels from '../../../../../constants/Channels'

const LeastPopularChannel = ({ channel, isEmpty, loading, t }) => {
    const { [channel]: selectedChannel } = Channels
    const { img, name } = selectedChannel || {}

    return <InfoBox isEmpty={isEmpty} loading={loading} title={t('Least Popular Channel')} value={name} img={img} />
}

LeastPopularChannel.propTypes = {
    channel: PropTypes.oneOf(Object.keys(Channels)),
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    t: PropTypes.func.isRequired,
}

LeastPopularChannel.defaultProps = {
    channel: null,
    isEmpty: true,
    loading: null,
}

export default withTranslation()(LeastPopularChannel)
